import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Stat, { IStatProps } from '../Stat';

export interface IStatsProps extends IBaseElementProps {
	heading?: string;
	text?: string;
	stats?: IStatProps[];
}

/**
 * Stats
 * @block
 * @requiresHooks
 * @icon editor-ol-rtl
 */
const Stats: React.FC<IStatsProps> = ({
	className,
	classNames = [],
	heading,
	text,
	stats = [],
}) => (
	<div className={className || cn('stats', ...classNames)}>
		<div className="stats__content">
			{heading && <h2 className="stats__heading">{heading}</h2>}
			{text && <p className="stats__text">{text}</p>}
		</div>
		<div className="stats__numbers">
			{stats.map((stat, index) => (
				<Stat key={index} {...stat} />
			))}
		</div>
	</div>
);

export default Stats;
